import { bemBuilder } from "@chatfood/core-utils";

const className = "mobile-header";

export const css = bemBuilder(className);
export const cssq = bemBuilder(className, true);
